module.exports = __webpack_public_path__ + "img/shape17.c9a7debb.png";